module.exports = __webpack_public_path__ + "static/media/smilng-girl.9a35199e.svg";